<div class="container" *ngIf="assinaturaDigitalEvento">

  <div class="container-card" *ngIf="assinaturaDigitalEvento.conteudoOriginal">
    <p-card styleClass="ui-card-shadow">
      <div class="container-conteudo">
        <p>
          <label class="titulo">
            PDF Original
          </label>
        </p>
        <div class="conteiner-descricao-conteudo-original">
          <label class="texto-cinza-claro">{{ assinaturaDigitalEvento.descricaoConteudoOriginal }}</label>
        </div>
      </div>
      <p-footer>
        <button
          (click)="salvarConteudoOriginal()"
          pButton
          type="button"
          label="{{ assinaturaDigitalEvento.descricaoConteudoOriginal === 'json' ? 'Download' : 'Abrir' }}"
          class="ui-button-secondary botao-abrir-download">
        </button>
      </p-footer>
    </p-card>
  </div>

  <div class="container-card" *ngIf="assinaturaDigitalEvento.conteudoAssinado">
    <p-card styleClass="ui-card-shadow">
      <div class="container-conteudo">
        <p>
          <label class="titulo">
            Conteúdo Assinado
          </label>
        </p>
        <label class="texto-cinza-claro">
          JSON
        </label>
      </div>
      <p-footer>
        <button
          (click)="salvarConteudoAssinado()"
          pButton
          type="button"
          label="Download"
          class="ui-button-secondary">
        </button>
      </p-footer>
    </p-card>
  </div>

  <div class="container-card" *ngIf="assinaturaDigitalEvento.conteudoAssinado">
    <p-card styleClass="ui-card-shadow">
      <div class="container-conteudo">
        <p>
          <label class="titulo">
            PDF Assinado
          </label>
        </p>
        <label class="texto-cinza-claro">
          PDF
        </label>
      </div>
      <p-footer>
        <button
          (click)="abrirPdfAssinado()"
          pButton
          type="button"
          label="Abrir"
          class="ui-button-secondary botao-abrir-download">
        </button>
      </p-footer>
    </p-card>
  </div>

</div>
